<div class="ca-processing" (paste)="onPaste($event)">
  <div class="ca-processing-toolbar">
    <label class="ca-processing-command-label" for="ca-processing-command-type">
      Command Type
    </label>
    <select
      id="ca-processing-command-type"
      class="form-control ca-processing-command-select"
      data-testid="processing-command-type-select"
      [ngModel]="selectedCommandType"
      (ngModelChange)="onCommandTypeChange($event)"
      [disabled]="availableEntries.length === 0 || gridLocked"
    >
      <option
        *ngFor="let entry of availableEntries"
        [value]="entry.commandType"
      >
        {{ entry.label }}
      </option>
    </select>

    <span [class]="statusPillClass" data-testid="processing-status-pill">
      {{ statusPillText }}
    </span>

    <span class="ca-processing-spacer"></span>

    <button
      nf-button="secondary"
      data-testid="processing-copy-headers-button"
      [disabled]="!activeEntry"
      (click)="copyHeaders()"
    >
      Copy Headers
    </button>
    <button
      nf-button="secondary"
      data-testid="processing-add-row-button"
      [disabled]="!activeEntry || gridLocked"
      (click)="addRow()"
    >
      Add Row
    </button>
    <button
      nf-button="secondary"
      data-testid="processing-clear-button"
      [disabled]="!activeEntry || gridLocked"
      (click)="clearAll()"
    >
      Clear
    </button>
    <button
      nf-button="primary"
      data-testid="processing-submit-button"
      [disabled]="submitDisabled"
      (click)="submit()"
    >
      Validate and Submit
    </button>
  </div>

  <div class="ca-processing-message" *ngIf="loadingCommands">
    Loading available commands&hellip;
  </div>
  <div
    class="ca-processing-message text-danger"
    data-testid="processing-commands-error"
    *ngIf="commandsError"
  >
    <span class="mdi mdi-alert-circle-outline"></span>
    {{ commandsError }}
    <!--
      The tab's ONLY recovery path. ngOnInit runs exactly once (the panel keeps
      this child alive after first activation) and the service is
      providedIn:'root', so neither a tab round trip nor re-adding the panel
      re-issues the fetch — see retryLoadCommands().
    -->
    <button
      nf-button="secondary"
      class="ca-processing-retry-button"
      data-testid="processing-retry-commands-button"
      [disabled]="loadingCommands"
      (click)="retryLoadCommands()"
    >
      Retry
    </button>
  </div>
  <div
    class="ca-processing-message text-muted"
    data-testid="processing-no-commands"
    *ngIf="!loadingCommands && !commandsError && availableEntries.length === 0"
  >
    {{ noCommandsMessage }}
  </div>

  <!--
    The grid stack the ticket names: `nf-grid-wrapper` / `nf-grid-wrapper-content`
    around `nf-table-layout`, the same wrapping both sibling grids in this lib use
    (`corporate-actions-grid`, `ice-corporate-actions-grid`) and the reason
    `account-summary` needs no component SCSS at all to size its grid. Search and
    Clear All are hidden because this tab owns its own toolbar above.
  -->
  <div class="ca-processing-grid" *ngIf="activeEntry">
    <nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
      <nf-grid-wrapper-content>
        <nf-table-layout
          [hideTitle]="true"
          [isSectionTitle]="false"
          [autoResizeGrid]="false"
          [gridOptions]="gridOptions"
          [modules]="gridModules"
          [data]="rowData"
          hideSearch
          hideClearAll
        >
        </nf-table-layout>
      </nf-grid-wrapper-content>
    </nf-grid-wrapper>
    <p class="ca-processing-hint text-muted">
      Paste tab-delimited rows from Excel to append them; use Copy Headers to
      get the column order.
    </p>
  </div>

  <div class="ca-processing-footer" *ngIf="activeEntry">
    <span data-testid="processing-footer-counts">
      {{ activeRows.length }} row(s) &middot; {{ validRowCount }} valid &middot;
      {{ invalidRowCount }} invalid<ng-container *ngIf="queuedRowCount > 0">
        &middot; {{ queuedRowCount }} submitted &mdash; queued</ng-container
      ><ng-container *ngIf="unconfirmedRowCount > 0">
        &middot; {{ unconfirmedRowCount }} unconfirmed</ng-container
      >
    </span>
    <span
      class="text-warning"
      data-testid="processing-unconfirmed-rows"
      *ngIf="unconfirmedRowCount > 0"
    >
      {{ unconfirmedRowCount }} row(s) unconfirmed &mdash; check the Commands
      drawer before resubmitting.
    </span>
    <span
      class="ca-processing-summary"
      data-testid="processing-submission-summary"
      *ngIf="lastSubmissionSummary"
    >
      {{ lastSubmissionSummary }}
    </span>
    <span
      class="text-danger"
      data-testid="processing-unmapped-results"
      *ngIf="unmappedResultCount > 0"
    >
      {{ unmappedResultCount }} result(s) could not be matched to a row.
    </span>
    <span
      class="text-danger"
      data-testid="processing-submit-error"
      *ngIf="submitError"
    >
      {{ submitError }}
    </span>
  </div>
</div>
